export const blogData = {
  osm: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/omega-seiki-mobility-to-supply-over-5000-electric-cargo-3-wheelers-to-porter-1688368566260-compressed.png`,
      imageTitle: "Benefits of commercial electric vehicle",
      heading: "OSM Goods Electric Auto: Everything You Need To Know",
      pathRoute: "/articles/osm-electric-auto-everything-you-need-to-know",
      subHeading: "",
      date: "Jul 3, 2023",
      author: "Turno Expert",
      description:
        "Turno welcomes you to explore the future of sustainable transportation with OSM Electric Vehicles. As the demand for eco-friendly and efficient mobility solutions grows, OSM Electric Auto emerges as a leading player in the market.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/osm-rage-the-ultimate-electric-auto-for-urban-cargo-transport-1686631964730-compressed.jpg`,
      imageTitle:
        "OSM Rage+ The Ultimate Electric Auto for Urban Cargo Transport",
      heading:
        "OSM Rage+: The Ultimate Electric Auto for Urban Cargo Transport",
      pathRoute: "/articles/osm-rage-for-urban-cargo-transport",
      subHeading: "",
      date: "May 8, 2023",
      author: "Turno Expert",
      description:
        "The OSM Rage is one of India's best and most economical electric three-whee​ler vehicles for urban cargo transit or loading gadi.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-14-1681716148691-compressed.jpg`,
      imageTitle:
        "Piaggio Ape Electrik vs OSM Rage +: A Comprehensive Comparison",
      heading: "Piaggio Ape Electrik vs OSM Rage +: A Comprehensive Comparison",
      pathRoute: "/articles/piaggio-ape-electrik-vs-osm-rage-plus",
      subHeading: "",
      date: "Apr 17, 2023",
      author: "Turno Expert",
      description:
        "Three-wheeler autos are becoming insanely popular in the commercial sector since they are an efficient and cost-effective solution for last-mile delivery. Among the notable options in the market are the Piaggio Ape Electrik and the OSM Rage +, two electric commercial vehicles that have gained attention for their unique features and capabilities. ",
    },
  ],

  piaggio: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-49-1685598121751-compressed.jpg`,
      imageTitle: "Piaggio Ape: An Auto That Offers Great Maneuverability",
      heading: "Piaggio Ape: An Auto That Offers Great Maneuverability",
      pathRoute:
        "/articles/piaggio-ape-an-auto-that-offers-great-maneuverability",
      subHeading: "",
      date: "May 3, 2023 ",
      author: "Turno Expert",
      description:
        "Are you tired of navigating through crowded streets and tight spaces in a large vehicle? Do you need a mode of transportation that is easy to drive and park in urban areas? Look no further than the Piaggio Ape. This three-wheeled light commercial vehicle has been in production for over 70 years and is known for its exceptional maneuverability. The electric version of the Piaggio Ape also features a flexible suspension system, which allows it to adapt to the contours of the road and maintain stability even on uneven surfaces. Additionally, the electric motor provides instant torque, which means that the Piaggio Ape electric auto can quickly accelerate and navigate through tight spaces with ease. The  other features that make the Piaggio Ape an ideal vehicle for navigating through narrow streets and crowded areas are covered in this blog. Whether you need to transport goods, people, or equipment, the Piaggio Ape offers a versatile and adaptable solution that can help you get the job done quickly and efficiently. Read on to learn more about this versatile and adaptable three-wheeled light commercial vehicle.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-52-1684748999241-compressed.jpg`,
      imageTitle:
        "Piaggio Ape Electric a Great Auto for Your Home Delivery Business",
      heading:
        "Piaggio Ape Electric a Great Auto for Your Home Delivery Business",
      pathRoute:
        "/articles/piaggio-ape-electric-auto-for-home-delivery-business",
      subHeading: "",
      date: "Apr 26, 2023      ",
      author: "Turno Expert",
      description:
        "Upgrade your home delivery services with the Piaggio Ape - the perfect compact, versatile, and fuel-efficient vehicle for your business needs.In recent years, the rise of e-commerce has made home delivery services more important than ever. From groceries to electronics, customers now expect to receive their orders at their doorstep. As a result, many small business owners are now venturing into the delivery service industry. However, finding the right vehicle for your delivery needs can be challenging. This is where the Piaggio Ape comes in – a reliable and efficient auto that is perfect for home delivery businesses.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-45-1684746156109-compressed.jpg`,
      imageTitle:
        "Piaggio Ape: A Great Investment for Startups and Small Businesses",
      heading:
        "Piaggio Ape: A Great Investment for Startups and Small Businesses",
      pathRoute:
        "/articles/a-great-investment-for-startups-and-small-businesses",
      subHeading: "",
      date: "Apr 17, 2023",
      author: "Turno Expert",
      description:
        "You need not look anywhere else than the Piaggio Ape if you're a small business owner or aspiring entrepreneur searching for an affordable and adaptable form of transportation for your enterprise. This distinctive three-wheeled electric vehicle is not only a useful option for city transport, but it also comes with a number of benefits that make it a wise investment for both new and small enterprises. We will examine the benefits of Piaggio Ape as an investment for your business in this article.",
    },
  ],
  mahindra: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-34-1687865100624-compressed.jpg`,
      imageTitle:
        "Mahindra Electric Auto: A Sustainable Solution for Commercial Use",
      heading:
        "Mahindra Electric Auto: A Sustainable Solution for Commercial Use",
      pathRoute:
        "/articles/mahindra-electric-auto-a-sustainable-solution-for-commercial-use",
      subHeading: "",
      date: "Jun 27, 2023",
      author: "Turno Expert",
      description:
        "Businesses are increasingly looking for sustainable and eco-friendly solutions for their company operations in today's fast-paced world. With a variety of electric cars designed specifically for business usage, Mahindra Electric Autos emerges as a market leader as demand for efficient transportation increases. Mahindra Pickup vehicles, such as the famed Mahindra Treo Zor and Mahindra Zor Grand, have completely changed the face of commercial transportation in India because to their remarkable performance, dependability, and environmentally friendly design. In this article, we'll look into the outstanding features and advantages of mahindra commercial vehicles, highlighting how important it is to promote sustainable practises and provide companies the tools they need to pursue more eco-friendly options.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-34-1687865100624-compressed.jpg`,
      imageTitle:
        "Understanding the Mahindra Tempo: Features, Variants, and Price Range",
      heading:
        "Understanding the Mahindra Tempo: Features, Variants, and Price Range",
      pathRoute: "/articles/understanding-the-mahindra-tempo-features",
      subHeading: "",
      date: "May 30, 2023      ",
      author: "Turno Expert",
      description:
        "In the bustling streets of India, reliable and efficient transportation is crucial for businesses to thrive. Recognizing this need, Mahindra, a trusted and innovative leader in the automotive industry, has introduced a range of tempos or electric loading vehicles that embody the essence of reliability, efficiency, and sustainability. With a focus on electric mobility, Mahindra has crafted the Mahindra Treo, Treo Zor, and Zor Grand tempos, promising to revolutionize the landscape of goods transportation across the nation. In this blog, we embark on a journey to unravel the remarkable performance capabilities of these Mahindra Tempos, shedding light on their unique features and showcasing how they empower businesses to thrive in the ever-evolving Indian market.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-4-1684840344683-compressed.jpg`,
      imageTitle:
        "Mahindra Loading Vehicle: Enhancing Efficiency and Productivity in Goods Transportation",
      heading:
        "Mahindra Loading Vehicle: Enhancing Efficiency and Productivity in Goods Transportation",
      pathRoute:
        "/articles/mahindra-loading-vehicle-enhancing-efficiency-and-productivity-in-goods-transportation",
      subHeading: "",
      date: "May 23, 2023",
      author: "Turno Expert",
      description:
        "In today's fast-paced business world, efficient transportation of goods is crucial for enhancing productivity and maintaining a competitive edge. As businesses increasingly prioritize sustainability and cost-effectiveness, Mahindra, a trusted name in the Indian automotive industry, offers a range of electric loading vehicles that are revolutionizing the way goods are transported. In this article, we will explore how Mahindra electric gadis like the Mahindra Treo, Mahindra Treo Zor, and Mahindra Zor Grand are transforming goods transportation, improving efficiency, and boosting productivity for businesses across India.",
    },
  ],
  euler: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-19-1685085023707-compressed.jpg`,
      imageTitle: "Electric Three Wheelers: The Future of Urban Mobility",
      heading: "Electric Three Wheelers: The Future of Urban Mobility",
      pathRoute:
        "/articles/electric-three-wheelers-the-future-of-urban-mobility",
      subHeading: "",
      date: "May 24, 2023    ",
      author: "Turno Expert",
      description:
        "Urban mobility in India is rapidly evolving, and the need for sustainable transportation solutions has never been more crucial. As cities become increasingly congested and air pollution continues to rise, the adoption of electric vehicles (EVs) especially loading gadis is gaining momentum. In this context, electric three-wheelers are emerging as a promising solution to revolutionize urban mobility in the country. With Indian automaker Mahindra leading the way, the Mahindra Treo Zor and Mahindra Zor Grand are setting new standards for electric three-wheelers, offering a cleaner, quieter, and more efficient mode of transportation.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-2-1688622800594-compressed.jpg`,
      imageTitle:
        "Euler HiLoad: Making Financing Easy for Your Electric Commercial Vehicle",
      heading:
        "Euler HiLoad: Making Financing Easy for Your Electric Commercial Vehicle",
      pathRoute:
        "/articles/euler-hiload-dv-vs-hiload-pv-financial-comparison",
      subHeading: "",
      date: "Jul 6, 2023      ",
      author: "Turno Expert",
      description:
        "Are you thinking about purchasing an electric commercial vehicle for your business? You should not miss out on considering the Euler HiLoad. The Euler HiLoad is changing the Indian logistics sector with its amazing features and performance. To guarantee a simple and easy purchasing experience when purchasing a new vehicle like the Euler HiLoad, a complete evaluation of financing choices is required. You can check out the various financing options in this blog so that you may make the right decision and take a step towards a future that is greener and more sustainable. ",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-45-1684746156109-compressed.jpg`,
      imageTitle: "Understanding the Cost of E-Rickshaw Batteries in India",
      heading: "Understanding the Cost of E-Rickshaw Batteries in India",
      pathRoute:
        "/articles/understanding-the-cost-of-e-rickshaw-batteries-in-india",
      subHeading: "",
      date: "Apr 18, 2023      ",
      author: "Turno Expert",
      description:
        "E-rickshaws, also known as electric rickshaws, have gained popularity as a means of transportation in India. They are a cost-effective and eco-friendly alternative to traditional auto-rickshaws that run on fossil fuels. E-rickshaws run on batteries that need to be replaced periodically. In this article, we will explore the cost of e-rickshaw batteries in India.",
    },
  ],
  etrio: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-15-1683622082163-compressed.jpg`,
      imageTitle: "Etrio Touro: The Perfect EV for Your Business Needs",
      heading: "Etrio Touro: The Perfect EV for Your Business Needs",
      pathRoute: "/articles/etrio-touro-for-your-business-needs",
      subHeading: "",
      date: "May 9, 2023   ",
      author: "Turno Expert",
      description:
        "Looking for an efficient and cost-effective vehicle for your business? Look no further than Etrio Touro - the electric loading gadi that's taking India by storm. With a range of up to 110 km and a top speed of 45 km/h, it's the perfect choice for local deliveries and transportation needs.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-2-1688622800594-compressed.jpg`,
      imageTitle: "Etrio Electric Cargo: 5 Reasons to Buy Through Turno",
      heading: "Etrio Electric Cargo: 5 Reasons to Buy Through Turno",
      pathRoute:
        "/articles/etrio-electric-cargo-5-reasons-to-buy-through-turno",
      subHeading: "",
      date: "Apr 10, 2023     ",
      author: "Turno Expert",
      description:
        "​Etrio Touro and Etrio eLCV are among the top cargo EVs variants from the renowned EV OEM Etrio. Etrio is an Indian manufacturer of cargo electric vehicles that provides high mileage and advanced architecture design. If you're considering purchasing a vehicle for your business, it's important to explore all of your options to make sure you get the best deal and maximize the value of your investment. While visiting a dealer can be a good starting point, there are other options available that can provide additional benefits and support.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-19-1685085023707-compressed.jpg`,
      imageTitle: "Electric Three Wheelers: The Future of Urban Mobility",
      heading: "Electric Three Wheelers: The Future of Urban Mobility",
      pathRoute:
        "/articles/electric-three-wheelers-the-future-of-urban-mobility",
      subHeading: "",
      date: "May 24, 2023    ",
      author: "Turno Expert",
      description:
        "Urban mobility in India is rapidly evolving, and the need for sustainable transportation solutions has never been more crucial. As cities become increasingly congested and air pollution continues to rise, the adoption of electric vehicles (EVs) especially loading gadis is gaining momentum. In this context, electric three-wheelers are emerging as a promising solution to revolutionize urban mobility in the country. With Indian automaker Mahindra leading the way, the Mahindra Treo Zor and Mahindra Zor Grand are setting new standards for electric three-wheelers, offering a cleaner, quieter, and more efficient mode of transportation.",
    },
  ],
  altigreen: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/642d25b75fb1be29d747e32e01-p-1080-1694085650350-compressed.jpg`,
      imageTitle: "Benefits of commercial electric vehicle",
      heading:
        "The Business Benefits of Choosing Altigreen Electric Commercial Vehicles",
      pathRoute:
        "/articles/business-benefits-of-choosing-altigreen-electric-commercial-vehicles",
      subHeading: "",
      date: "Sep 7, 2023",
      author: "Turno Expert",
      description:
        "The future of commercial transportation is electric, and Altigreen is leading the charge with innovative electric commercial vehicles (EVs) that offer a multitude of business benefits. In a world where sustainability and cost-effectiveness are paramount, Altigreen Auto and Altigreen Truck provide compelling solutions for businesses of all sizes. In this blog, we'll explore the advantages of choosing Altigreen electric vehicles for your commercial operations.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/6381b92873b91e56e67049a001-1694432268218-compressed.png`,
      imageTitle:
        "Innovative Engineering: Unveiling Altigreen's Breakthrough Electric Commercial Vehicles",
      heading:
        "Innovative Engineering: Unveiling Altigreen's Breakthrough Electric Commercial Vehicles",
      pathRoute:
        "/articles/innovative-engineering-altigreen-electric-commercial-vehicles",
      subHeading: "",
      date: "Aug 30, 2023    ",
      author: "Turno Expert",
      description:
        "In a world where technology meets profitability and sustainability, Altigreen stands out like a superhero in the realm of electric commercial vehicles (EVs). These vehicles aren't just ordinary; they're like magical cars that use electricity, boosting profits and promoting sustainable choices. Let's dive into Altigreen's impressive technology and discover two incredible EVs they offer: the Altigreen neEV and Altigreen neEV Tez – both are super-efficient three-wheeler trucks.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-14-1681716148691-compressed.jpg`,
      imageTitle: "Exploring the Different Types of Electric Loading Autos",
      heading: "Exploring the Different Types of Electric Loading Autos",
      pathRoute: "/articles/different-types-of-electric-loading-autos",
      subHeading: "",
      date: "Aug 23, 2023",
      author: "Turno Expert",
      description:
        "Electric loading autos are a type of electric vehicle that is designed for urban delivery and logistics. These electric commercial vehicles are compact and more maneuverable than trucks, making them ideal for navigating crowded city streets. Electric loading autos are also maintenance free, making them a more sustainable option for urban transportation.",
    },
  ],
  greaves: [
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/2-1-1694607154926-compressed.jpg`,
      imageTitle:
        "Greaves Eltra vs. Traditional Three-Wheelers: Which Is the Better Business Investment?",
      heading:
        "Greaves Eltra vs. Traditional Three-Wheelers: Which Is the Better Business Investment?",
      pathRoute: "/articles/greaves-eltra-vs-traditional-three-wheelers",
      subHeading: "",
      date: "Sep 13, 2023    ",
      author: "Turno Expert",
      description:
        "In the ever-evolving landscape of last-mile delivery and cargo transportation, businesses are constantly seeking cost-effective and efficient solutions.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/blog-14-1681716148691-compressed.jpg`,

      imageTitle:
        "Innovative Engineering: Unveiling Altigreen's Breakthrough Electric Commercial Vehicles",
      heading:
        "Innovative Engineering: Unveiling Altigreen's Breakthrough Electric Commercial Vehicles",
      pathRoute:
        "/articles/innovative-engineering-altigreen-electric-commercial-vehicles",
      subHeading: "",
      date: "Aug 30, 2023    ",
      author: "Turno Expert",
      description:
        "In a world where technology meets profitability and sustainability, Altigreen stands out like a superhero in the realm of electric commercial vehicles (EVs). These vehicles aren't just ordinary; they're like magical cars that use electricity, boosting profits and promoting sustainable choices. Let's dive into Altigreen's impressive technology and discover two incredible EVs they offer: the Altigreen neEV and Altigreen neEV Tez – both are super-efficient three-wheeler trucks.",
    },
    {
      imageUrl: `https://assets.superblog.ai/site_cuid_clgagehuu1385291qqxjlqc86ye/images/2-1-1695211321591-compressed.jpg`,

      imageTitle:
        "Greaves Eltra: A Closer Look at Key Features and Customization Options",
      heading:
        "Greaves Eltra: A Closer Look at Key Features and Customization Options",
      pathRoute: "/articles/greaves-eltra-closer-look-at-key-features",
      subHeading: "",
      date: "Sep 20, 2023",
      author: "Turno Expert",
      description:
        "In the ever-evolving landscape of electric commercial vehicles, Greaves Eltra stands out as a formidable player. With a strong commitment to innovation, sustainability, and performance, Greaves Electric Mobility has been making waves in the industry.",
    },
  ],
};
